module.exports = __webpack_public_path__ + "img/avatar-placeholder.388ca0b.png";